import { createSelector } from '@ngrx/store';
import { OverlayStateInterface } from './overlay.state';
import { getOverlayState } from '../store/store.selectors';

export const getOverlayStatus = createSelector(
  getOverlayState,
  (state: OverlayStateInterface) => state.isOverlayActive
);
